module.exports = __webpack_public_path__ + "src/assets/textures/env/wagon/wagon_front_right_wheel_256_bake.png";